import { Drawer } from 'antd';
import type { TabelaPrecoProduto } from '@/features/tabela-preco/types/TabelaPrecoProduto';
import type { Dialog } from '@/std/dialog/types';
import { ProdutoTabTabelaPrecoDrawerExcecao } from './ProdutoTabTabelaPrecoDrawerExcecao';
import { ProdutoTabTabelaPrecoDrawerInfo } from './ProdutoTabTabelaPrecoDrawerInfo';

export function ProdutoTabTabelaPrecoDrawer({
    dialog,
    produtoIdpk,
}: {
    dialog: Dialog<TabelaPrecoProduto>;
    produtoIdpk: number;
}) {
    const tabelaPreco = dialog.state.data;

    return (
        <Drawer
            onClose={() => dialog.actions.close()}
            open={dialog.state.open}
            title='Tabela de preço'
        >
            {tabelaPreco && (
                <>
                    <ProdutoTabTabelaPrecoDrawerInfo tabelaPreco={tabelaPreco} />
                    <ProdutoTabTabelaPrecoDrawerExcecao
                        dialog={dialog}
                        produtoIdpk={produtoIdpk}
                        tabelaPreco={tabelaPreco}
                    />
                </>
            )}
        </Drawer>
    );
}
